export const messages = {
    en: {
        addToFavorites: "Successfully added to your favorite",
        removeFromFavorites: "Successfully removed from the favorite",
        nameEmpty: "Name cannot be empty.",
        emailEmpty: "Email Address cannot be empty.",
        emailNotValid: "Email Address is not valid, please enter a proper email address.",
        locationEmpty: "Location cannot be empty.",
        interests: "Select 3 area of interest.",
        profileSaved: "Profile details saved.",
        profilePic: "Profile picture saved.",
        registerSuccess:"Registered successfully.",
        passwordNotMatch:"Password doesn't match.",
        emailFormate:"Please enter proper email format.",
        verificationEmailSentto:"Verification email sent to your registered email.",
        somethingWentWrong:"Something went wrong."
    },
    th: {
        addToFavorites: "เพิ่มไปยังรายการโปรดของคุณสำเร็จแล้ว",
        removeFromFavorites: "ลบออกจากรายการโปรดสำเร็จแล้ว",
        nameEmpty: "ชื่อไม่สามารถเว้นว่างได้",
        emailEmpty: "ที่อยู่อีเมลไม่สามารถเว้นว่างได้",
        emailNotValid: "ที่อยู่อีเมลไม่ถูกต้อง โปรดกรอกที่อยู่อีเมลที่ถูกต้อง",
        locationEmpty: "ที่ตั้งไม่สามารถเว้นว่างได้",
        interests: "โปรดเลือก 3 สาขาความสนใจ",
        profileSaved: "บันทึกรายละเอียดโปรไฟล์เรียบร้อยแล้ว",
        profilePic: "บันทึกรูปโปรไฟล์เรียบร้อยแล้ว",
        registerSuccess: "ลงทะเบียนสำเร็จ",
        passwordNotMatch: "รหัสผ่านไม่ตรงกัน",
        emailFormate: "โปรดกรอกอีเมลในรูปแบบที่ถูกต้อง",
        verificationEmailSentto: "อีเมลยืนยันถูกส่งไปยังอีเมลที่ลงทะเบียนแล้ว",
        somethingWentWrong: "เกิดข้อผิดพลาดบางอย่าง"
    },    
    fr: {
        addToFavorites: "Ajouté avec succès à vos favoris",
        removeFromFavorites: "Retiré avec succès de la liste des favoris",
        nameEmpty: "Le nom ne peut pas être vide.",
        emailEmpty: "L'adresse e-mail ne peut pas être vide.",
        emailNotValid: "L'adresse e-mail n'est pas valide, veuillez entrer une adresse e-mail correcte.",
        locationEmpty: "L'emplacement ne peut pas être vide.",
        interests: "Sélectionnez 3 domaines d'intérêt.",
        profileSaved: "Les détails du profil sont sauvegardés.",
        profilePic: "Sauvegarde de la photo de profil.",
        registerSuccess:"Registered successfully.",
        passwordNotMatch:"Password doesn't match.",
        emailFormate:"Please enter proper email format.",
        verificationEmailSentto:"Verification email sent to your registered email.",
        somethingWentWrong:"Something went wrong."
    },
    de: {
        addToFavorites: "Wurde den Favoriten erfolgreich hinzugefügt",
        removeFromFavorites: "Wurde aus den Favoriten erfolgreich entfernt",
        nameEmpty: "Namensfeld muss ausgefüllt werden.",
        emailEmpty: "E-Mail-Adresse muss angegeben werden.",
        emailNotValid: "Die E-Mail-Adresse ist ungültig.",
        locationEmpty: "Der Standort muss angegeben werden.",
        interests: "Wähle 3 Interessenbereiche aus.",
        profileSaved: "Profildaten wurden gespeichert.",
        profilePic: "Profilbild wurde gespeichert.",
        registerSuccess:"Registered successfully.",
        passwordNotMatch:"Password doesn't match.",
        emailFormate:"Please enter proper email format.",
        verificationEmailSentto:"Verification email sent to your registered email.",
        somethingWentWrong:"Something went wrong."
    },
    be: {
        addToFavorites: "Met succes toegevoegd aan je favoriet",
        removeFromFavorites: "Met succes van de favoriet verwijderd",
        nameEmpty: "Naam mag niet leeg zijn",
        emailEmpty: "E- mailadres mag niet leeg zijn.",
        emailNotValid: "E- mailadres is niet geldig, voer een correct e- mailadres in.",
        locationEmpty: "Locatie mag niet leeg zijn.",
        interests: "Selecteer 3 interessegebied.",
        profileSaved: "Profielgegevens opgeslagen.",
        profilePic: "Profielfoto opgeslagen.",
        registerSuccess:"Registered successfully.",
        passwordNotMatch:"Password doesn't match.",
        emailFormate:"Please enter proper email format.",
        verificationEmailSentto:"Verification email sent to your registered email.",
        somethingWentWrong:"Something went wrong."
        
    },
    tr: {
        addToFavorites: "Favorilere başarıyla eklendi",
        removeFromFavorites: "Favorilerden başarıyla kaldırıldı",
        nameEmpty: "İsim alanı boş bırakılamaz",
        emailEmpty: "Email adresi boş bırakılamaz",
        emailNotValid: "Geçersiz email, lütfen doğru bir adres girin",
        locationEmpty: "Lokasyon boş bırakılamaz",
        interests: "3 ilgi alanı seçiniz",
        profileSaved: "Profil ayarlari kaydedildi",
        profilePic: "Profil resmi kaydedildi",
        registerSuccess:"Registered successfully.",
        passwordNotMatch:"Password doesn't match.",
        emailFormate:"Please enter proper email format.",
        verificationEmailSentto:"Verification email sent to your registered email.",
        somethingWentWrong:"Something went wrong."
    },
    pt: {
        addToFavorites: "Adicionado com sucesso ao seu favorito",
        removeFromFavorites: "Removido com sucesso do favorito",
        nameEmpty: "O campo de nome não pode estar vazio.",
        emailEmpty: "O campo Endereço de email não pode estar vazio.",
        emailNotValid: "O endereço de email não é válido.",
        locationEmpty: "O campo de localização não pode estar vazio.",
        interests: "Selecione 3 áreas de interesse.",
        profileSaved: "Detalhe do perfil guardado",
        profilePic: "Foto do perfil salva",
        registerSuccess:"Registrado com sucesso.",
        passwordNotMatch:"Senhas não correspondem.",
        emailFormate:"Por favor, insira um e-mail válido.",
        verificationEmailSentto:"E-mail de verificação enviado para seu e-mail registrado.",
        somethingWentWrong:"Algo deu errado"
    },
    ee: {
        addToFavorites: "Edukalt lisatud oma lemmikute hulka",
        removeFromFavorites: "Edukalt eemaldatud lemmikute hulgast",
        nameEmpty: "Nimi ei saa tühi olla",
        emailEmpty: "E-posti aadress ei tohi tühi olla",
        emailNotValid: "E-posti aadress ei kehti, palun sisesta õige e-posti aadress.",
        locationEmpty: "Asukoht ei saa tühi olla.",
        interests: "Vali 3 huvivaldkonda",
        profileSaved: "Profiili detailid salvestatud.",
        profilePic: "Profiilipilt Salvestatud",
        registerSuccess:"Registreerumine õnnestus.",
        passwordNotMatch:"Parool ei ühti",
        emailFormate:"Sisestage õige e-posti vorming.",
        verificationEmailSentto:"Teie registreeritud meilile saadeti kinnitusmeil",
        somethingWentWrong:"Midagi läks valesti"
    },
    es: {
        addToFavorites: "Añadido correctamente a tu favorito",
        removeFromFavorites: "Eliminado correctamente de tu favorito",
        nameEmpty: "El nombre no puede estar vacío.",
        emailEmpty: "La dirección de e-mail no puede estar vacía.",
        emailNotValid: "La dirección de e-mail no es válida, por favor ingrese una dirección de correo electrónico adecuada.",
        locationEmpty: "La ubicación no puede estar vacía.",
        interests: "Seleccione 3 áreas de interés",
        profileSaved: "Datos del perfil guardados.",
        profilePic: "Foto del perfil guardada.",
        registerSuccess:"Registrado correctamente.",
        passwordNotMatch:"La contraseña no coincide.",
        emailFormate:"Ingrese el formato de correo electrónico adecuado.",
        verificationEmailSentto:"Correo electrónico de verificación enviado a su correo electrónico registrado.",
        somethingWentWrong:"Algo salió mal.",
        unsubscribeSuccess: "Cancelación de suscripción exitosa.",
        unsubscribeNotFound: "Suscripción no encontrada.",
        unsubscribeFailed: "Error al cancelar suscripción. Por favor, inténtelo de nuevo."
    },
    it: {
        addToFavorites: "Aggiunti con successo ai preferiti",
        removeFromFavorites: "Rimossi con successo dai preferiti",
        nameEmpty: "Il campo del nome non può essere vuoto",
        emailEmpty: "Il campo dell'indirizzo e-mail non può essere vuoto",
        emailNotValid: "Indirizzo e-mail non valido",
        locationEmpty: "Il campo della posizione non può essere vuoto",
        interests: "Seleziona 3 aree di interesse",
        profileSaved: "Informazioni del profilo salvati",
        profilePic: "Foto del profilo salvata",
        registerSuccess:"Registered successfully.",
        passwordNotMatch:"Password doesn't match.",
        emailFormate:"Please enter proper email format.",
        verificationEmailSentto:"Verification email sent to your registered email.",
        somethingWentWrong:"Something went wrong."
    },
    el: {
        addToFavorites: "Προστέθηκε με επιτυχία στα αγαπημένα σας",
        removeFromFavorites: "Καταργήθηκε με επιτυχία από τα αγαπημένα",
        nameEmpty: "Το όνομα δεν μπορεί να είναι κενό",
        emailEmpty: "Η διεύθυνση email δεν μπορεί να είναι κενή",
        emailNotValid: "Η διεύθυνση email δεν είναι έγκυρη",
        locationEmpty: "Η τοποθεσία δεν μπορεί να είναι κενή",
        interests: "Επιλέξτε 3 τομείς ενδιαφέροντος",
        profileSaved: "Τα στοιχεία του προφίλ αποθηκεύτηκαν.",
        profilePic: "Η εικόνα προφίλ αποθηκεύτηκε.",
        registerSuccess:"Registered successfully.",
        passwordNotMatch:"Password doesn't match.",
        emailFormate:"Please enter proper email format.",
        verificationEmailSentto:"Verification email sent to your registered email.",
        somethingWentWrong:"Something went wrong."
    },
    id: {
        addToFavorites: "Berhasil ditambahkan ke favorit Anda",
        removeFromFavorites: "Berhasil dihapus dari favorit",
        nameEmpty: "Nama tidak boleh kosong.",
        emailEmpty: "Alamat Email tidak boleh kosong.",
        emailNotValid: "Alamat email tidak valid, silakan masukkan alamat email yang benar.",
        locationEmpty: "Lokasi tidak boleh kosong.",
        interests: "Pilih 3 bidang minat.",
        profileSaved: "Detail profil disimpan.",
        profilePic: "Gambar profil disimpan.",
        registerSuccess:"Pendaftaran berhasil.",
        passwordNotMatch:"Kata sandi tidak cocok.",
        emailFormate:"Silakan masukkan format email yang benar.",
        verificationEmailSentto:"Email verifikasi dikirimkan ke email Anda yang terdaftar.",
        somethingWentWrong:"Ada yang tidak beres."
    },
};



// WEBPACK FOOTER //
// ./src/constants/messages.js